module.exports = __webpack_public_path__ + "img/acacia-aerial-1.69c3b2ca.webp";